import { render, staticRenderFns } from "./SensitivityRatingPicker.vue?vue&type=template&id=20d08cf0&"
import script from "./SensitivityRatingPicker.vue?vue&type=script&lang=js&"
export * from "./SensitivityRatingPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports